import isEqual from 'lodash/isEqual';

export default function(o1: Record<string, Any>, o2: Record<string, Any>, omitUndefined = false) {
  const d: Record<string, Any> = {};

  const o1Keys = Object.keys(o1);

  o1Keys.forEach((k) => {
    const areValuesEqual = isEqual(o1[k], o2[k]);

    if (!areValuesEqual && (!omitUndefined || (o1[k] !== undefined && o2[k] !== undefined))) {
      d[k] = o1[k];
    }
  });

  return d;
}
